/**
 * Normalize Stream/API attachment objects for chat rendering.
 * Prefer `attachments`, fall back to `originalAttachments`.
 */
export const resolveChatAttachmentMediaKind = (attachment = {}) => {
  const typeHint = String(
    attachment.mediaType ?? attachment.fileType ?? attachment.type ?? '',
  ).toLowerCase();
  const url = String(attachment.url ?? attachment.uri ?? '').trim();

  if (typeHint.includes('video') || /\.(mp4|webm|ogg|mov)(\?|$)/i.test(url)) {
    return 'video';
  }
  if (typeHint.includes('image') || /\.(jpe?g|png|gif|webp|heic|bmp)(\?|$)/i.test(url)) {
    return 'image';
  }
  return 'file';
};

export const normalizePartnerGroupChannelAttachments = (message = {}) => {
  const primary = Array.isArray(message.attachments) ? message.attachments : [];
  const fallback = Array.isArray(message.originalAttachments) ? message.originalAttachments : [];
  const source = primary.length ? primary : fallback;

  return source
    .map((attachment, index) => {
      if (!attachment || typeof attachment !== 'object') return null;
      const url = String(attachment.url ?? attachment.uri ?? '').trim();
      if (!url) return null;

      const mediaKind = resolveChatAttachmentMediaKind(attachment);
      const fileName =
        String(attachment.fileName ?? attachment.name ?? '').trim() || `Attachment ${index + 1}`;
      const mimeType =
        String(attachment.fileType ?? attachment.type ?? '').trim() ||
        (mediaKind === 'video' ? 'video/mp4' : mediaKind === 'image' ? 'image/jpeg' : '');

      return {
        id: attachment.id ?? `${url}-${index}`,
        url,
        fileName,
        mimeType,
        mediaKind,
        fileSize: attachment.fileSize ?? null,
      };
    })
    .filter(Boolean);
};

export const messageHasChatAttachments = (message = {}) =>
  normalizePartnerGroupChannelAttachments(message).length > 0;
